import reframe from "reframe.js";

import { setupSearch } from "./search";
import { setupModals } from "./modal";
import { setupPrimaryNavigation } from "./navigation";
import { setupLightbox } from "./lightbox";
import { setupIframeStyles } from "./iframe";
import { setupCarousels } from "./carousel";
import { setupSyntaxHighlighting } from "./syntax-highlighting";
import { PaginationType, setupInfiniteScroll, setupLoadMoreScroll } from "./pagination";
import { setupProgressiveWebApp } from "./pwa";
import { setupScrollIndicator } from "./scroll-indicator";
import { setupFooterNav } from "./footer";
import { setupMobileTooltips } from "./tooltip";
import { setupDarkColorScheme } from "./colorScheme";

type ThemeConfig = {
  enableSyntaxHighlighting?: boolean,
  enableAppMode?: boolean,
  enableScrollIndicator?: boolean,
  paginationType?: PaginationType,
  darkColorScheme?: string,
  site: {
    url: string,
    title: string,
    description: string,
    accentColor: string,
    icon: string,
  },
};

type WindowWithThemeConfig = Window & { themeConfig?: ThemeConfig };

reframe('iframe');
setupFooterNav();
setupSearch();
setupModals();
setupMobileTooltips();
setupPrimaryNavigation();
setupLightbox();
setupIframeStyles();
setupCarousels();
const themeConfig = (window as WindowWithThemeConfig).themeConfig;

if (themeConfig.enableSyntaxHighlighting) {
  setupSyntaxHighlighting();
}

if (themeConfig.enableAppMode) {
  setupProgressiveWebApp(themeConfig.site);
}

if(themeConfig.enableScrollIndicator) {
  setupScrollIndicator();
}

if (themeConfig.darkColorScheme) {
  setupDarkColorScheme(themeConfig.darkColorScheme);
}

switch (themeConfig.paginationType) {
  case PaginationType.InfiniteScroll:
    setupInfiniteScroll();
    break;
  case PaginationType.LoadMore:
    setupLoadMoreScroll();
    break;
}